import { LonaWebComponent, html } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";

@component({ name: "std-chat-loading-dots" })
export class ChatLoadingDots extends LonaWebComponent {
  static makeWith(): ChatLoadingDots {
    return ChatLoadingDots.make() as ChatLoadingDots;
  }

  static $html: Option<HTMLTemplateElement> = html`
    <div id="root">
      <div id="d0" class="dot"></div>
      <div id="d1" class="dot"></div>
      <div id="d2" class="dot"></div>
    </div>
  `;

  static $styles = [
    css`
      :host {
        display: inline-block;
      }
      #root {
        display: flex;
        gap: 4px;
        align-items: center;
        padding: 4px 0;
      }
      .dot {
        width: 6px;
        height: 6px;
        flex-shrink: 0;
        border-radius: 50%;
        background-color: currentColor;
        animation: chat-loading-wave 1.2s ease-in-out infinite;
      }
      #d1 { animation-delay: 0.15s; }
      #d2 { animation-delay: 0.3s; }
      @keyframes chat-loading-wave {
        0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
        30% { transform: translateY(-4px); opacity: 1; }
      }
    `,
  ];
}
